module.exports = __webpack_public_path__ + "static/img/ds-nv@2x.a151d67f.png";